// extracted by mini-css-extract-plugin
export default {"divError":"ErrorBoundary_divError__xx0Bh","logo":"ErrorBoundary_logo__c185j"};